<template>
    <ul class="rightList">
        <li
        v-for="(item,index) in list"
        :key="index"
        :class="[{active: rightListState[item.index].flag},'gzw_daj']"
        @click="setRightListState(item.index)"
        >
            <img :src="rightListState[item.index].flag?item.url2:item.url1">
            {{ item.title }}
        </li>
    </ul>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let mapData = createNamespacedHelpers("mapData");
const publicData = createNamespacedHelpers("publicData");
export default {
    data() {
        return {
            list: [
                {
                    url1: require("@/assets/svg/map/right0.svg"),
                    url2: require("@/assets/svg/map/right0_active.svg"),
                    title: "酒店",
                    index: 0,
                },
                {
                    url1: require("@/assets/svg/map/right1.svg"),
                    url2: require("@/assets/svg/map/right1_active.svg"),
                    title: "民宿",
                    index: 1,
                },
                {
                    url1: require("@/assets/svg/map/right2.svg"),
                    url2: require("@/assets/svg/map/right2_active.svg"),
                    title: "餐饮",
                    index: 2,
                },
                // {
                //     url1: require("@/assets/svg/map/right3.svg"),
                //     url2: require("@/assets/svg/map/right3_active.svg"),
                //     title: "娱",
                //     index: 4,
                // }
            ]
        }
    },
    mounted(){
        if(this.getIntoTheState != 0){
            if(this.firstLevelIndex == 3){
                this.setRightListState(this.secondLevelIndex);
            }
        }
    },
    methods: {
        rightListClick(index){

        },
        ...mapData.mapMutations(["setRightListState"])
    },
    computed: {
        ...mapData.mapState(["rightListState"]),
        ...publicData.mapState(["getIntoTheState","secondLevelIndex","firstLevelIndex"]),
    },
    props: {
        initState: {
            type: Boolean
        }
    },
    watch: {
        initState(nv){
            if(this.getIntoTheState != 0 && nv){
                if(this.firstLevelIndex == 3){
                    this.setRightListState(this.secondLevelIndex);
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.rightList{
    width: 1rem;
    height: auto;
    position: absolute;
    right: .66rem;
    bottom: 2.31rem;
    li{
        width: 100%;
        height: 1rem;
        background: #fff;
        border-radius: 50%;
        box-shadow:0px .08rem .8rem 0px rgba(50,50,50,0.2);
        margin-top: .3rem;
        font-size: .18rem;
        color: #999;
        flex-direction: column;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: .4rem;
            height: .4rem;
            margin-bottom: .06rem;
        }
        &.active{
            color: #58BFA7;
        }
    }
}
</style>